<section
  class="assistant-hero bg-blue-gradient-top-right stretch"
  aria-labelledby="assistant-hero-title"
>
  <div class="assistant-hero-content">
    <!-- `--l` pins 48/56, the `Article/Desktop M-L/Heading/H1` token the mock
         uses. The unsuffixed class is responsive and reaches 60/64 at this
         frame's width, which is a size larger than the handoff. -->
    <h1 id="assistant-hero-title" class="article-heading-1--l">
      {{ title() }}
    </h1>
    <p class="article-body-m assistant-hero-lead">{{ description() }}</p>

    <div class="assistant-hero-search">
      <inexp-search-input
        class="full-width"
        [placeholder]="searchPlaceholder()"
        [buttonText]="searchButtonText()"
        [showAutocomplete]="true"
        [isSearchEnabled]="isSearchEnabled()"
        (searchSubmit)="search($event)"
      >
        <inexp-sparkle-icon searchButtonIcon />
      </inexp-search-input>
    </div>

    <!-- The catalog is probed before navigating, so there is a beat where
         nothing has changed yet. Saying so beats looking frozen. -->
    <p class="assistant-hero-status" role="status">
      @if (isResolving()) {
        <rds-progress-spinner size="s" />
        Looking through the catalog…
      }
    </p>

    <inexp-prompt-chips
      [prompts]="prompts"
      label="Suggested questions"
      (promptSelected)="search($event)"
    />
  </div>
</section>
